import { render, staticRenderFns } from "./ClaimsTrendChart.vue?vue&type=template&id=642eb222&scoped=true"
import script from "./ClaimsTrendChart.vue?vue&type=script&lang=js"
export * from "./ClaimsTrendChart.vue?vue&type=script&lang=js"
import style0 from "./ClaimsTrendChart.vue?vue&type=style&index=0&id=642eb222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642eb222",
  null
  
)

export default component.exports